import { __t } from 'common/i18n';
import Layout from 'common/Layout/Layout';
import { Button, Flex, Paper, Text } from 'common/styles';
import TextField from 'common/TextField';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useState } from 'react';

export default function QrEntry() {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const { push } = useRouter();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code) {
      setLoading(true);
      push(`/tv/${code}`);
    }
  };

  return (
    <Layout>
      <Head>
        <title>{__t('auth.tv.pageTitle')} | {__t('static_siteName')}</title>
      </Head>
      <Paper m="0 auto" py={{ xs: 3, md: 6 }} px={{ xs: 2, md: 4 }} maxWidth="xs">
        <Flex as="form" direction="column" onSubmit={handleSubmit}>
          <Text align="center" variant="h2">{__t('auth.tv.entry.title')}</Text>
          <Text align="center" mb={3}>{__t('auth.tv.entry.helperText')}</Text>
          <TextField
            name="code"
            value={code}
            onChange={(e) => { setCode(e.target.value); }}
            mb={2}
          />
          <Button type="submit" disabled={!code || loading} variant="primaryA">
            {__t('auth.tv.entry.submit')}
          </Button>
        </Flex>
      </Paper>
    </Layout>
  );
}
